// extracted by mini-css-extract-plugin
module.exports = {"onboardingSection":"Onboarding_onboardingSection__FuoPa"};